import { render, staticRenderFns } from "./UetsList.vue?vue&type=template&id=8b95d0ec&scoped=true&"
import script from "./UetsList.vue?vue&type=script&lang=js&"
export * from "./UetsList.vue?vue&type=script&lang=js&"
import style0 from "./UetsList.vue?vue&type=style&index=0&id=8b95d0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95d0ec",
  null
  
)

export default component.exports